module.exports = __webpack_public_path__ + "img/marker.100922ac.jpg";